import {useMutation, useQueryClient} from '@tanstack/react-query'
import {parseAxiosPromise} from '@/axiosInstance.ts'
import {
    httpUpdateFreelancer,
    HttpUpdateFreelancerOptionsDescriptionPayload
} from '@features/settings/http/settings.http.ts'
import {User} from '@features/user/types.ts'
import {captureException} from '@sentry/react'
import {errorHandler} from '@utilities/helpers.ts'
import {QUERY_KEYS} from '@/queryClient.ts'
import {z} from 'zod'

const ResponseShape = User.pick({description: true})
type ResponseShape = z.infer<typeof ResponseShape>

export const useChangeFreelancerDescription = ({userId, onSuccess}: {userId: number; onSuccess: () => void}) => {
    const queryClient = useQueryClient()

    return useMutation<ResponseShape, unknown, HttpUpdateFreelancerOptionsDescriptionPayload>({
        mutationFn: variables =>
            parseAxiosPromise({
                axiosPromise: httpUpdateFreelancer({
                    payload: variables,
                    urlParams: {userId}
                }),
                responseShape: ResponseShape,
                onZodError: captureException
            }),
        onError: errorHandler,
        onSuccess: async data => {
            onSuccess()
            await queryClient.cancelQueries({queryKey: [QUERY_KEYS.ME]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.REQUIRED_ACTIONS]})
            queryClient.setQueryData(
                [QUERY_KEYS.ME],
                (previousData: User): User => ({
                    ...previousData,
                    description: data.description
                })
            )
        }
    })
}
